import { Injectable, OnDestroy } from '@angular/core'
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router'
import { UserService } from '@core/user.service'
import { KeycloakAuthGuard, KeycloakEventType, KeycloakService } from 'keycloak-angular'
import { Subject } from 'rxjs'

@Injectable()
export class AuthService extends KeycloakAuthGuard implements OnDestroy {
   console: boolean = false
   logPrefix: string = '@AuthService - ' + this.constructor.name

   licenceSubject$: Subject<boolean> = new Subject<boolean>()

   constructor(
      protected router: Router,
      public keycloakAngular: KeycloakService,
      public user: UserService
   ) {
      super(router, keycloakAngular)

      keycloakAngular.keycloakEvents$.subscribe({
         next: (event) => {
            switch (event.type) {
               case KeycloakEventType.OnAuthError:
                  this.keycloakEventLog(event.type)
                  break
               case KeycloakEventType.OnAuthLogout:
                  this.keycloakEventLog(event.type)
                  this.keycloakAngular.logout()
                  break
               case KeycloakEventType.OnAuthRefreshError:
                  this.keycloakEventLog(event.type)
                  keycloakAngular.login()
                  break
               case KeycloakEventType.OnAuthRefreshSuccess:
                  this.keycloakEventLog(event.type)
                  this.licenceSubject$.next(this.hasLicence())
                  break
               case KeycloakEventType.OnAuthSuccess:
                  this.keycloakEventLog(event.type)
                  break
               case KeycloakEventType.OnReady:
                  this.keycloakEventLog(event.type)
                  break
               case KeycloakEventType.OnTokenExpired:
                  this.keycloakEventLog(event.type)
                  keycloakAngular.updateToken(5)
                  break
               default:
                  break
            }
         },
      })
   }

   ngOnDestroy(): void {
      this.keycloakAngular.keycloakEvents$.unsubscribe()
   }

   hasLicence() {
      let roles = this.keycloakAngular.getUserRoles(true)
      return roles.includes('LICENCE_PEOPLE_TOOL')
   }

   async isUserLogged() {
      return await this.keycloakAngular.isLoggedIn()
   }

   async isAccessAllowed(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
      return new Promise(async (resolve, reject) => {
         console.log(this.logPrefix, 'isAccessAllowed')
         if (!this.authenticated) {
            console.log(this.logPrefix, 'no allowed')
            await this.keycloakAngular.login().catch((e) => console.error(e))
            reject(false)
         }
         resolve(true)
      })
   }

   logout() {
      this.keycloakAngular.logout()
   }

   private keycloakEventLog(type: KeycloakEventType) {
      if (this.console) console.log(this.logPrefix, 'Keycloak event - Type: ' + KeycloakEventType[type])
   }
}

